class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("cart-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.initSlider();
        }
      })
      .catch((e) => {
        /*console.error(e);*/
      });
  }

  initSlider() {
    const slider = this.querySelector(".js-mini-cart-recommendations-products");
    if (!slider || typeof Flickity === 'undefined') return;

    this.flickity = new Flickity(slider, {
      accessibility: false,
      prevNextButtons: false,
      pageDots: false,
      autoPlay: false,
      wrapAround: false,
      cellAlign: "left",
      contain: true
    });

    this.prevBtn = this.querySelector(".js-mini-cart-recommendations-previous");
    this.nextBtn = this.querySelector(".js-mini-cart-recommendations-next");

    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", () => this.flickity.previous());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", () => this.flickity.next());
    }

    this.flickity.on("select", () => this.updateArrowState());

    this.updateArrowState();

    // Ensure flickity product cards height aligned
    const cards = slider.querySelectorAll('.flickity-cell');
    cards.forEach(card => {
      card.style.height = '100%';
    });
  }

  updateArrowState() {
    if (!this.flickity) return;
    if (!this.prevBtn || !this.nextBtn) return;

    const index = this.flickity.selectedIndex;
    const lastIndex = this.flickity.cells.length - 1;

    this.prevBtn.disabled = index === 0;
    this.nextBtn.disabled = index === lastIndex;
  }
}

customElements.define("cart-recommendations", CartRecommendations);